import React from 'react';
import { Modal, Button } from 'antd';
import PropTypes from 'prop-types';
import SecondaryMarketIdentityUpload from '../SecondaryMarketIdentityUpload/SecondaryMarketIdentityUpload';
import SecondaryListingAgreementModal from '../SecondaryListingAgreementModal/SecondaryListingAgreementModal';
import './SecondaryMarketAccessModal.scss';

const SecondaryMarketAccessModal = ({ visible, subStep, modalState, onRemindLater, onAgreementSuccess, identificationDocs }) => {

  const hasIdentificationDocs = identificationDocs && Object.keys(identificationDocs).length > 0;

  const handleStartApplication = () => {
    // If user already has uploaded ID docs, skip identity upload and go straight to agreement
    if (hasIdentificationDocs) {
      modalState('AccessModal_Agreement');
    } else {
      modalState('AccessModal_Identity');
    }
  };

  const handleIdentityUploadClose = () => {
    modalState('AccessModal');
  };

  const handleIdentityUploadSuccess = (docs) => {
    // Document uploaded successfully, now show agreement modal
    modalState('AccessModal_Agreement');
  };

  const handleAgreementSuccess = () => {
    // Agreement accepted, open the buy modal
    if (onAgreementSuccess) {
      onAgreementSuccess();
    } else if (onRemindLater) {
      onRemindLater();
    }
  };

  const handleAgreementClose = () => {
    // User closed agreement without accepting, return to main screen
    modalState('AccessModal');
  };

  return (
    <>
      <Modal
        open={visible && subStep === 'AccessModal'}
        footer={null}
        closable={true}
        onCancel={onRemindLater}
        centered
        width={600}
        className='secondary-market-access-modal'
      >
        <h2 className='modal-title'>Unlock Your Trading Access</h2>
        <p className='modal-description'>
          Apply today to access Realbricks' Secondary Marketplace and get full control over your real estate investments. Buy and sell shares from other investors with ease.
        </p>
        <div className='modal-actions'>
          <Button type='primary' className='start-btn' onClick={handleStartApplication}>
            Start Application
          </Button>
          <Button className='remind-btn' onClick={onRemindLater}>
            Remind me later
          </Button>
        </div>
      </Modal>

      <SecondaryMarketIdentityUpload
        visible={subStep === 'AccessModal_Identity'}
        onClose={handleIdentityUploadClose}
        onSuccess={handleIdentityUploadSuccess}
      />

      <SecondaryListingAgreementModal
        visible={subStep === 'AccessModal_Agreement'}
        onClose={handleAgreementClose}
        onSuccess={handleAgreementSuccess}
      />
    </>
  );
};

SecondaryMarketAccessModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  subStep: PropTypes.string,
  modalState: PropTypes.func.isRequired,
  onRemindLater: PropTypes.func.isRequired,
  onAgreementSuccess: PropTypes.func,
  identificationDocs: PropTypes.object,
};

export default SecondaryMarketAccessModal;
